<template>
  <div class="pregunta-table">
    <table>
      <thead>
        <tr>
          <th>ID</th>
          <th>Texto</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="pregunta in preguntas" :key="pregunta.id">
          <td>{{ pregunta.id }}</td>
          <td>{{ pregunta.texto }}</td>
          <td>
            <ButtonPrime label="Editar" @click="editarPregunta(pregunta)" />
            <ButtonPrime label="Eliminar" @click="eliminarPregunta(pregunta.id)" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { ButtonPrime } from 'primevue/button';

export default defineComponent({
  components: {
    ButtonPrime,
  },
  props: {
    preguntas: Array,
    editarPregunta: Function,
    eliminarPregunta: Function,
  },
});
</script>

<style scoped>
.pregunta-table {
  width: 100%;
}
.pregunta-table table {
  width: 100%;
  border-collapse: collapse;
}
.pregunta-table th, .pregunta-table td {
  border: 1px solid #ddd;
  padding: 8px;
}
</style>